import React, {useEffect, useState} from 'react'
import { Form, Tab, Tabs } from 'react-bootstrap'
import { changePassword, getConfigs, saveConfig, uData, updateUser } from '../../api/api';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import {DeleteForever } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import Cookie from 'react-cookies';
const VoteConfig = () => {
	const navigate = useNavigate()
	const [data, setData ] = useState();
    const [updateData, setUpdateData] = useState({});
    const [config, setConfig] = useState();
    
    const handleChange = (e) => {
        setData({ ...data, [e.target.name] : e.target.value});
        // let d = new Date();
        // console.log(Date.now())
    }
    const handleUpdateChange = (e, i)=>{
        // setUpdateData({ ...updateData, [e.target.name] : e.target.value});
        setConfig([...config.slice(0, i), {
            ...config[i], [e.target.name]: e.target.value
        }])
    }
    const handleUpdate = async (d) => {
        console.log(d);
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
            const res = await saveConfig(data);
            console.log(res);
            if(res.success){
                Swal.fire({
                    title: 'Successful',
                    icon:"success",
                    text: res.message,
                    closeButtonHtml: `<button className="btn btn-color"> Close </button>` 
                })
                e.target.reset();
            }else{
                Swal.fire({
                    title: 'Failed',
                    icon:"error",
                    text: res.message,
                    closeButtonHtml: `<button className="btn btn-color"> Close </button>` 
                })
            }
        
    }
    const fetchConfig = async () => {
        const res = await getConfigs();
        console.log(res)
        setConfig(res.data);
    }
	useEffect(() => {
		document.title = 'Vote Config | Taste Place Investment'
        fetchConfig();
	}, [])
    useEffect(() => {
        console.log(config)
    }, [data, updateData, config])

  return (
    <div className='m-1 px-2 py-5'
	style={{ 
		backgroundColor: 'whitesmoke',
		height: '99vh'
	 }}
	>
		<h4><b className=" mb-5"> Voting Configuration </b></h4> 
      <Tabs>
        <Tab eventKey={'new'} title='New Config'>
            <div className="card">
                <div className="card-body">
                    <form action="" id="newUser"
                    onSubmit={handleSubmit}
                    >
                        <table className=' table'>
                        <div className="row justify-content-center">
                            <div className="col-12" >
                                <thead >
                                    <tr>
                                        <th> Year </th>
                                        <th> Start Date </th>
                                        <th className=''> End Date </th>
                                    </tr>
                                </thead>
                                <tbody >
                                    <tr className='my-2'>
                                        <td>
                                            <div className="form-group mx-2 my-3">
                                                <Form.Select  name="year" className="form-control form-control-sm" 
                                                onChange={handleChange}
                                                required
                                                >
                                                    <option> Select Year...</option>
                                                    <option value={'2025'}> 2025</option>
                                                    <option value={'2026'}> 2026</option>
                                                    <option value={'2027'}> 2027</option>
                                                    <option value={'2028'}> 2028</option>
                                                    <option value={'2029'}> 2029</option>
                                                    <option value={'2030'}> 2030</option>
                                                    <option value={'2031'}> 2031</option>
                                                    <option value={'2032'}> 2032</option>
                                                    <option value={'2033'}> 2033</option>
                                                    <option value={'2034'}> 2034</option>
                                                    <option value={'2035'}> 2035</option>
                                                    <option value={'2036'}> 2036</option>
                                                    <option value={'2037'}> 2037</option>
                                                    <option value={'2038'}> 2038</option>
                                                    <option value={'2039'}> 2039</option>
                                                    <option value={'2040'}> 2040</option>
                                                    <option value={'2041'}> 2041</option>
                                                    <option value={'2042'}> 2042</option>
                                                    <option value={'2043'}> 2043</option>
                                                    <option value={'2044'}> 2044</option>
                                                    <option value={'2045'}> 2045</option>
                                                </Form.Select>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='form-group mx-2'>
                                            <input name='start' type='date' className='form-control' 
                                            onChange={handleChange}
                                            />
                                            </div>
                                        </td>
                                        <td>
                                            <div className='form-group mx-2'>
                                                <input name='end' type='date' className='form-control' 
                                                onChange={handleChange}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </div>
                        </div>
                        </table>
                        <hr />
                        <div className="col-lg-12 text-right justify-content-center d-flex">
                            <button className="btn btn-danger btn-lg" type="button" 
                            onClick={()=> {
                                navigate('/dashboard');
                            }}
                            //  style={{ width: '120px' }}
                            >close</button>
                            <button
                            
                            className="btn btn-color btn-lg ms-2"
                            //   style={{ width: '120px' }}
                            >Save</button> 
                        </div>
                    </form>
                </div>
            </div>
        </Tab>
        <Tab eventKey={'update'} title='Update Config'>
            <div className="card">
                <div className="card-body">
                    <form action="" id="newUser"
                    // onSubmit={handleUpdate}
                    >
                        <table className=' table'>
                        <div className="row justify-content-center">
                            <div className="col-12" >
                                <thead>
                                    <tr>
                                        <th> Year </th>
                                        <th> Start Date </th>
                                        <th className='text-center'> End Date </th>
                                        <th className='text-center'> Action </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        config && config.map((d, i) => (
                                            <tr>
                                                <td>
                                                    <div className="form-group mx-2">
                                                       <Form.Select  name="year" className="form-control form-control-sm" 
                                                        onChange={(e)=>handleUpdateChange(e, i,)}
                                                        value={d.year}
                                                        disabled={d.active ? false : true}
                                                        required
                                                        >
                                                            <option> Select Year...</option>
                                                            <option value={'2025'}> 2025</option>
                                                            <option value={'2026'}> 2026</option>
                                                            <option value={'2027'}> 2027</option>
                                                            <option value={'2028'}> 2028</option>
                                                            <option value={'2029'}> 2029</option>
                                                            <option value={'2030'}> 2030</option>
                                                            <option value={'2031'}> 2031</option>
                                                            <option value={'2032'}> 2032</option>
                                                            <option value={'2033'}> 2033</option>
                                                            <option value={'2034'}> 2034</option>
                                                            <option value={'2035'}> 2035</option>
                                                            <option value={'2036'}> 2036</option>
                                                            <option value={'2037'}> 2037</option>
                                                            <option value={'2038'}> 2038</option>
                                                            <option value={'2039'}> 2039</option>
                                                            <option value={'2040'}> 2040</option>
                                                            <option value={'2041'}> 2041</option>
                                                            <option value={'2042'}> 2042</option>
                                                            <option value={'2043'}> 2043</option>
                                                            <option value={'2044'}> 2044</option>
                                                            <option value={'2045'}> 2045</option>
                                                        </Form.Select>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='form-group mx-2'>
                                                    <input name='start' type='date' className='form-control' 
                                                    value={d.start}
                                                    disabled={d.active ? false : true}
                                                    onChange={(e)=>handleUpdateChange(e, i,)}
                                                    />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='form-group mx-2'>
                                                        <input name='end' type='date' className='form-control' 
                                                        value={d.end}
                                                        disabled={d.active ? false : true}
                                                        onChange={(e)=>handleUpdateChange(e, i,)}
                                                        />
                                                    </div>
                                                </td>
                                                <div className='card-body'>
                                                    <td>
                                                        <div className='form-group mx-2 mt-1'>
                                                        <button className='form-control btn btn-color btn-sm'
                                                        type='button' 
                                                        style={{ width: '100px' }}
                                                        onClick={()=> {
                                                            setConfig([...config.slice(0, i), {
                                                                ...config[i], active: true
                                                            }])
                                                        }}
                                                        disabled={d.active ? true : false}
                                                        >
                                                                Edit
                                                        </button>
                                                        </div>
                                                        <div className='form-group mx-2 mt-1'>
                                                        <button className='form-control btn btn-color btn-sm'
                                                        type='button' 
                                                        style={{ width: '100px' }}
                                                        onClick={()=> handleUpdate(d)}
                                                        disabled={d.active ? false : true}
                                                        >
                                                                Save
                                                        </button>
                                                        </div>
                                                    </td>
                                                </div>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </div>
                        </div>
                        </table>
                        <hr />
                        {/* <div className="col-lg-12 text-right justify-content-center d-flex">
                            <button className="btn btn-danger btn-lg" type="button" 
                            onClick={()=> {
                                navigate('/dashboard');
                            }}
                            //  style={{ width: '120px' }}
                            >Cancel</button>
                            <button
                            
                            className="btn btn-color btn-lg ms-2"
                            //   style={{ width: '120px' }}
                            >Continue</button> 
                        </div> */}
                    </form>
                </div>
            </div>
        </Tab>
      </Tabs>
    </div>
  )
}

export default VoteConfig